import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  selector: 'app-promote-hdma-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule
  ],
  templateUrl: './promote-hdma-dialog.component.html',
  styleUrl: './promote-hdma-dialog.component.scss'
})
export class PromoteHdmaDialogComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly dialogRef: MatDialogRef<PromoteHdmaDialogComponent> = inject(
    MatDialogRef<PromoteHdmaDialogComponent>
  );
  public readonly data = inject<{ contactName: string; currentHDMAName: string; isAdminView: boolean; isInstitutionView: boolean }>(MAT_DIALOG_DATA);

  public form: FormGroup;
  public contactName: string;
  public currentHDMAName: string;
  public confirmationWord = 'PROMOTE';
  public isInstitutionView = false;
  public isAdminView = false;

  constructor() {
    this.contactName = this.data.contactName;
    this.currentHDMAName = this.data.currentHDMAName;
    this.isAdminView = this.data.isAdminView;
    this.isInstitutionView = this.data.isInstitutionView;

    this.form = this.formBuilder.nonNullable.group({
      confirmationText: ['', [Validators.required, this.confirmationValidator.bind(this)]]
    });
  }

  private confirmationValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value && control.value.toUpperCase() !== this.confirmationWord) {
      return { invalidConfirmation: true };
    }
    return null;
  }

  get isConfirmationValid(): boolean {
    return this.form.get('confirmationText')?.value?.toUpperCase() === this.confirmationWord;
  }

  protected handleConfirm(): void {
    if (this.isConfirmationValid) {
      this.dialogRef.close(true);
    }
  }

  protected handleCancel(): void {
    this.dialogRef.close(false);
  }
}
